import { SxProps, Theme } from '@mui/material'

export const planWrapperSx = ({
  isHighlighted,
  isLoading,
  planSetWidth,
}: {
  isHighlighted?: boolean
  isCustomPlan?: boolean
  isLoading?: boolean
  planSetWidth: number
}): SxProps<Theme> => {
  return {
    width: {
      xs: '100%',
      xl: '27.36rem',
    },
    minHeight: '32.3rem',
    [`@media (max-width: ${planSetWidth - 1}px)`]: {
      minHeight: '34.3rem',
      paddingBottom: '4rem',
    },
    [`@media (min-width: ${planSetWidth}px)`]: {
      minHeight: '32.3rem',
      paddingBottom: '1.6rem',
    },
    borderRadius: '1.2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.6rem',
    gap: '0.8rem',
    ...(isLoading && { justifyContent: 'center' }),
    backgroundColor: (theme) =>
      isHighlighted ? theme.palette.secondary.main : undefined,
    color: (theme) =>
      isHighlighted ? theme.palette.primary.contrastText : undefined,
  }
}

export const customPlanContainerSx: SxProps<Theme> = {
  alignItems: 'center',
  gap: '0.8rem',
}

export const highestPaymentFrequenciesContainerSx: SxProps<Theme> = {
  alignItems: 'center',
  spacing: '0.2rem',
}

export const otherPaymentFrequenciesContainerSx: SxProps<Theme> = {
  alignItems: 'center',
  spacing: '0.4rem',
}

export const loadingWrapperSx: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export const loadingSx = ({
  isHighlighted,
}: {
  isHighlighted?: boolean
}): SxProps<Theme> => {
  return {
    color: (theme) =>
      isHighlighted
        ? theme.palette.background.paper
        : theme.palette.primary.main,
  }
}

export const customIconSx = ({
  isHighlighted,
}: {
  isHighlighted?: boolean
}): SxProps<Theme> => {
  return {
    width: '5.6rem',
    height: '5.6rem',
    marginBottom: '0.8rem',
    alignSelf: 'center',
    color: (theme) =>
      isHighlighted ? theme.palette.common.white : theme.palette.secondary.main,
  }
}

export const highestPaymentFrequencySx: SxProps<Theme> = {
  fontWeight: 700,
  lineHeight: '4.9rem',
}

export const paymentFrequencySx: SxProps<Theme> = {
  lineHeight: '2.5rem',
}

export const perMonthSx: SxProps<Theme> = {
  marginTop: '0 !important',
}

export const planButtonSx = ({
  isHighlighted,
  isAvailable,
}: {
  isHighlighted?: boolean
  isAvailable?: boolean
}): SxProps<Theme> => {
  return {
    alignSelf: 'center',
    marginTop: '0.3rem',
    height: '5.2rem',
    color: (theme) =>
      isHighlighted ? theme.palette.secondary.main : theme.palette.primary.main,

    ...(isHighlighted && {
      transition: 'all 0.2s ease-in-out',

      ...(isAvailable
        ? {
            color: (theme) => theme.palette.secondary.dark,
            borderColor: (theme) => theme.palette.secondary.dark,
            backgroundColor: (theme) => theme.palette.background.paper,
            '&:hover': {
              backgroundColor: (theme) => theme.palette.background.paper,
              opacity: '0.7',
            },
          }
        : {
            color: (theme) => theme.palette.common.white,
            borderColor: (theme) => theme.palette.common.white,
            backgroundColor: 'transparent',
            '&:hover': {
              borderColor: (theme) => theme.palette.common.white,
            },
          }),
    }),
  }
}

export const contentWrapperSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
  gap: '0.8rem',
}
